import { Route } from 'vue-router';
import store from '../store';

export default async function (to: Route, from: Route, next: any) {
  const { isUserLoggedIn } = store.getters;
  const isGoToAuth = to.fullPath.includes('auth');
  console.log(to.fullPath, from.fullPath, isUserLoggedIn, isGoToAuth);
  if (!isUserLoggedIn) {
    const verifyUser = await store.dispatch('checkUserToken');
    if (!isGoToAuth) {
      if (!verifyUser) {
        return next('/auth');
      }
      next();
    }
    if (isGoToAuth) {
      if (verifyUser) {
        return next({
          name: 'stats',
        });
      }
      next();
    }
    return next();
  }
  if (isGoToAuth) {
    return next({
      name: 'stats',
    });
  }
  return next();
}
